<template>
  <div>
    <!-- @row-click="rowclick"
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange" -->
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="maxHeight ? undefined : tableHeigth"
        :max-height="maxHeight ? maxHeight : undefined"
        header-align="center"
        :data="TableDataALl"
        border
        stripe
        :ref="tbRef"
        :highlight-current-row="true"
        :show-summary="showSummary"
        :summary-method="getSummaries"
        @row-click="rowclick"
        @selection-change="handleSelectionChange"
        :row-key="theRowKey"
        :cell-style="cellStyle"
      >
        <el-table-column
          v-if="isindex"
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          v-if="isselection"
          :selectable="selectable"
          reserve-selection
          fixed="left"
          align="left"
          type="selection"
          width="60"
        >
        </el-table-column>
        <template
          v-for="(item, index) in myTableHeard.filter((item) => item.isShow)"
        >
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <el-table-column
              align="left"
              :prop="item.field"
              :width="item.width ? parseInt(item.width) : ''"
              :show-overflow-tooltip="true"
              v-if="showFilter"
            >
              <template #header v-if="myTableHeard.length > 0">
                <div class="glo_disFlex">
                  <el-input
                    type="text"
                    @input="onHeaderCheckSearch"
                    clearable
                    v-model="theadScreen[item.field]"
                    placeholder="请输入"
                  />
                  <i
                    v-if="TableDataALl.length > 0"
                    @click="openGroup(item)"
                    class="el-icon-s-unfold glo_tbSelectIcon"
                  ></i>
                </div>
              </template>
              <template #default="scope">
                <!-- <div
                  v-if="item.field == 'commandNumber'"
                  class="linkTabel"
                  @click.stop="addModifyBtns(scope.row, 2)"
                >
                  {{ scope.row.commandNumber }}
                </div> -->
                <!-- 可以点击操作的列 -->
                <div
                  v-if="fieldList.length > 0 && fieldList.includes(item.field)"
                  class="linkTabel"
                  @click.stop="fildsClick(scope.row, item.field)"
                >
                  {{ scope.row[item.field] }}
                </div>
                <div
                  v-else-if="
                    dbFields.length > 0 && dbFields.includes(item.field)
                  "
                  class="db-clickable"
                  @dblclick.stop="fieldDbClick(scope.row, item.field)"
                >
                  {{ scope.row[item.field] }}
                </div>
                <!-- 默认的列 -->
                <slot
                  :name="item.field"
                  :row="scope.row"
                  :index="scope.$index"
                  v-else
                >
                  {{ scope.row[item.field] }}
                </slot>
              </template>
            </el-table-column>
            <template #default="scope" v-if="!showFilter">
              <!-- <div
                  v-if="item.field == 'commandNumber'"
                  class="linkTabel"
                  @click.stop="addModifyBtns(scope.row, 2)"
                >
                  {{ scope.row.commandNumber }}
                </div> -->
              <!-- 可以点击操作的列 -->
              <div
                v-if="fieldList.length > 0 && fieldList.includes(item.field)"
                class="linkTabel"
                @click.stop="fildsClick(scope.row, item.field)"
              >
                {{ scope.row[item.field] }}
              </div>
              <div
                v-else-if="dbFields.length > 0 && dbFields.includes(item.field)"
                class="db-clickable"
                @dblclick.stop="fieldDbClick(scope.row, item.field)"
              >
                {{ scope.row[item.field] }}
              </div>
              <slot
                :name="item.field"
                :row="scope.row"
                :index="scope.$index"
                v-else
              >
                {{ scope.row[item.field] }}
              </slot>
            </template>
          </el-table-column>
          <slot :name="'extra_' + item.field"></slot>
        </template>
        <slot name="extra"></slot>
        <el-table-column
          fixed="right"
          label="操作"
          :width="Operatewidth"
          v-if="isShowOperate2"
        >
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-for="(itemA, idxA) in btnsList2"
                :key="idxA"
                class="rbtns"
                v-show="
                  typeof itemA.show === 'function'
                    ? itemA.show(scope.row)
                    : itemA.show !== false
                "
                @click.stop="OperateFn(scope.row, itemA.methods, itemA.param)"
                >{{ itemA.name }}</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <el-dropdown
                v-if="isShowMoreOperate2"
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(itemB, idxB) in btnsMoreList2"
                    :key="idxB"
                    :command="itemB.command"
                    >{{ itemB.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 表格搜索弹窗 -->
    <myDialog
      :diaWidth="diaWidthA"
      :dialogTitle="dialogTitleA"
      :isShowDialog="isShowDialogA"
      :showCacel="false"
      :showConfirm="false"
      :dialogFooter="false"
      :isCloseModal="true"
      @handleCloseDia="isShowDialogA = false"
    >
      <el-checkbox-group v-model="checkList" @change="changeGroupList">
        <el-checkbox
          class="TBcheckBoxItem"
          v-for="(itemA, idxA) in groupList"
          :key="idxA"
          :label="itemA.name"
        >
          {{ itemA.name }} ({{ itemA.number }})
        </el-checkbox>
      </el-checkbox-group>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
export default {
  components: {
    myDialog,
  },
  props: {
    maxHeight: {
      typeof: String,
      require: false,
      default: "",
    },
    rowKey: {
      type: String,
      require: false,
      default: null,
    },
    // 表格数据
    tableData: {
      typeof: Array,
      default() {
        return [];
      },
    },
    // 表头
    myTableHeard: {
      typeof: Array,
      require: false,
      default() {
        return [];
      },
    },
    // 表格右边操作按钮
    btnsList: {
      typeof: Array,
      require: false,
      default() {
        return [];
      },
    },
    // 表格右边更多操作按钮
    btnsMoreList: {
      typeof: Array,
      require: false,
      default() {
        return [];
      },
    },
    // 表格特殊标记的字段
    fieldList: {
      typeof: Array,
      require: false,
      default() {
        return [];
      },
    },
    // 双击字段
    dbFields: {
      typeof: Array,
      require: false,
      default() {
        return [];
      },
    },
    //表格高度
    tableHeigth: {
      typeof: String,
      require: false,
      default: "75vh",
    },
    // 操作列宽
    Operatewidth: {
      typeof: String,
      require: false,
      default: "100px",
    },
    // 表格的ref
    tableRef: {
      typeof: String,
      default: "mytable",
    },
    // 是否显示操作列
    isShowOperate: {
      typeof: Boolean,
      require: false,
      default: false,
    },
    // 是否显示更多的操作
    isShowMoreOperate: {
      typeof: Boolean,
      require: false,
      default: false,
    },
    // 是否可以选择
    isselection: {
      typeof: Boolean,
      require: false,
      default: true,
    },
    // 是否显示序号
    isindex: {
      typeof: Boolean,
      require: false,
      default: true,
    },
    // showFilter: {
    //   type: Boolean,
    //   require: false,
    //   default: true,
    // },
    customSelection: {
      type: Boolean,
      require: false,
      default: false,
    },
    showSummary: {
      type: Boolean,
      require: false,
      default: true,
    },
    rowStyleKey: {
      type: String,
      require: "",
      default: "",
    },
  },
  data() {
    return {
      // 统一加上
      showFilter: true,
      diaWidthA: "260px",
      dialogTitleA: "",
      isShowDialogA: false,
      groupKey: "",
      groupList: [],
      checkList: [],
      theadScreen: {},
      TableDataALl: [], //前端本地显示的表格数据
      totalArr: [], //  表格需要合计的字段
      tbRef: "mytable",
      btnsList2: [],
      btnsMoreList2: [],
      isShowOperate2: false,
      isShowMoreOperate2: false,
    };
  },
  watch: {
    tableData: {
      handler(a, b) {
        this.TableDataALl = a;
        this.clearSelection();
      },
      deep: true,
      immediate: true,
    },
    myTableHeard: {
      handler(a, b) {
        const totalArr = []
        for (var i = 0; i < a.length; i++) {
            if (a[i].isTotal) {
              totalArr.push(a[i].field);
            }
          }
        this.totalArr = totalArr;
      },
      deep: true,
      immediate: true,
    },
    tableRef: {
      handler(a, b) {
        this.tbRef = a;
      },
      deep: true,
      immediate: true,
    },
    btnsList: {
      handler(v) {
        this.btnsList2 = v.filter((item) => {
          const permission = item.permission;
          if (!permission && permission !== false) {
            return true;
          }
          if (permission instanceof Boolean) {
            return permission;
          }
          return this.hasPermiss(permission);
        });
      },
      deep: true,
      immediate: true,
    },
    btnsMoreList: {
      handler(v) {
        this.btnsMoreList2 = v.filter((item) => {
          const permission = item.permission;
          if (!permission && permission !== false) {
            return true;
          }
          if (permission instanceof Boolean) {
            return permission;
          }
          return this.hasPermiss(permission);
        });
      },
      deep: true,
      immediate: true,
    },
    isShowOperate: {
      handler(v) {
        this.isShowOperate2 = v && this.btnsList2.length > 0;
      },
      deep: true,
      immediate: true,
    },
    isShowMoreOperate: {
      handler(v) {
        this.isShowMoreOperate2 = v && this.btnsMoreList2.length > 0;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    cellStyle({ row }, column, rowIndex, columnIndex) {
      if (!this.rowStyleKey) {
        return false;
      }
      if (row[this.rowStyleKey] === 1) {
        return { backgroundColor: "#f1a7a7" };
      }
      return {};
    },
    // 操作按钮回调  fn==按钮方法名称,data==这行数据,type==自定义的一个参数
    OperateFn(data, fn, type) {
      //this.$emit("OperateFn", data, fn, type);
      if (this.$parent.OperateFn) {
        this.$emit("OperateFn", data, fn, type);
        return;
      }
      this.$parent[fn](data, type);
    },
    // 更多操作
    handleCommandBtns(command, data) {
      this.$emit("handleCommandBtns", command, data);
    },
    // 可以点击的列
    fildsClick(data, field) {
      this.$emit("fildsClick", data, field);
    },
    // 双击点击列
    fieldDbClick(data, field) {
      this.$emit("fieldDbClick", data, field);
    },

    // 打开搜索弹窗
    openGroup(data) {
      let val = data.field;

      let oldData = JSON.parse(JSON.stringify(this.TableDataALl));
      let arrs = [];
      oldData.forEach((item) => {
        if (item[val]) {
          let objs = {
            name: item[val],
            field: val,
          };
          arrs.push(objs);
        }
      });
      //  去重
      let uniqueList = arrs.reduce((acc, cur) => {
        if (!acc.find((item) => item.name === cur.name)) {
          acc.push(cur);
        }
        return acc;
      }, []);
      uniqueList.forEach((itemA) => {
        itemA.number = 0;
        arrs.forEach((itemB) => {
          if (itemA.name == itemB.name) {
            itemA.number++;
          }
        });
      });
      this.groupList = uniqueList;

      this.checkList = [];
      this.dialogTitleA = data.name;
      this.isShowDialogA = true;
      this.groupKey = val;
    },
    changeGroupList(e) {
      let str = e.join(",");
      this.theadScreen[this.groupKey] = str;

      this.onHeaderCheckSearch();
    },
    // 标题输入搜索
    onHeaderCheckSearch(e) {
      let oldData = JSON.parse(JSON.stringify(this.tableData));

      let arr = []; //输入框有值的项
      for (var k in this.theadScreen) {
        if (this.theadScreen[k]) {
          let obj = {
            key: k,
            val: this.theadScreen[k],
          };
          arr.push(obj);
        }
      }
      if (arr.length == 0) {
        this.TableDataALl = this.tableData;
        return false;
      }

      let arr1 = oldData.filter((item) => {
        let isTrue = true;
        arr.forEach((itemB) => {
          let arrB = itemB.val.split(",");
          if (
            (item[itemB.key] &&
              String(item[itemB.key]).indexOf(itemB.val) !== -1) ||
            arrB.includes(String(item[itemB.key]))
          ) {
          } else {
            isTrue = false;
          }
        });
        return isTrue;
      });

      //网点A   默认部门,网点A
      // let arr1 = oldData.filter((item) => {
      //   let isTrue = true;
      //   arr.forEach((itemB) => {
      //     console.log("itemB", itemB.val);
      //     let arrB = itemB.val.split(",");
      //     if (arrB.includes(String(item[itemB.key]))) {
      //     } else {
      //       isTrue = false;
      //     }
      //   });
      //   return isTrue;
      // });

      this.TableDataALl = arr1;
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs[this.tbRef].doLayout();
      });
      return sums;
    },
    handleSelectionChange(e) {
      e.map((item) => (item.selected = true));
      if (this.customSelection) {
        this.$emit("handleSelectionChange", e);
        return;
      }
      if (this.$parent.handleSelectionChange) {
        this.$parent.handleSelectionChange(e);
      } else {
        this.$emit("handleSelectionChange", e);
      }
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs[this.tbRef].toggleRowSelection(row);
    },
    selectable(row, index) {
      return row.selectable !== false;
    },
    refresh() {
      this.doLayout();
    },
    doLayout() {
      this.$refs[this.tbRef].doLayout();
    },
    resetCheckbox(row) {
      this.$refs[this.tbRef].toggleRowSelection(row);
      this.$refs[this.tbRef].store.commit("rowSelectedChanged", row);
    },
    selectAll() {
      this.$refs[this.tbRef].toggleAllSelection();
    },
    theRowKey(row) {
      return row[this.rowKey];
    },
    clearSelection() {
      this.$refs[this.tbRef] && this.$refs[this.tbRef].clearSelection();
    },
    getRow(event) {
      let ele = event.target;
      let clazz = ele.classList;
      while (!clazz.contains("el-table__row")) {
        ele = ele.parentElement;
        clazz = ele.classList;
      }
      const index = ele.rowIndex;
      return {
        index,
        row: this.tableData[index],
      };
    },
    selectRow(row) {
      this.$refs[this.tbRef].toggleRowSelection(row, true);
    },
  },
};
</script>
<style scoped lang='less'>
.glo_Table {
  /deep/ .el-input__suffix {
    display: flex;
    align-items: center;
  }
}
</style>